import React from 'react';
import DatePicker from "react-datepicker";
import { registerLocale } from  "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from 'date-fns/locale/pt';
import { subtrairDias, somarDias } from '../../util/Data'
import ValidaDataOcorrencia from './ValidaDataOcorrencia'

registerLocale('pt', pt);

export default function DataOcorrencia(props) {

    const abreFormularioEnvolvidos = () => {
        props.setMensagem({ tipo:'LIMPAR', texto:'' })
        ValidaDataOcorrencia.valida(props.dataAcontecimento)
        .then( dataAcontecimento => {
            props.setDataAcontecimento(dataAcontecimento)
            props.atuLinhaDoTempo('envolvidos')
        })
        .catch( msgErro => {
            props.setMensagem(msgErro)
        })
    }

    const abreFormularioLocal = () => {
        props.atuLinhaDoTempo('local')
    }

    if (props.formularioEmPauta === "Nova denúncia" || props.linhaDoTempo.emPauta !== "dataHora") {
        return null;
    }

    return (
        <fieldset className="border p-2 mt-4">
            <legend className="row w-auto">
                <h4 className="ml-4"><small>Data e hora da ocorrência:</small></h4> 
            </legend>
            <div className="form-group col-sm-10">
                <div id="idCloseCalendar">Data:</div>
                <DatePicker
                    showTimeSelect
                    locale="pt"
                    timeFormat="p"
                    timeIntervals={15}
                    dateFormat="dd/MM/yyyy HH:mm"
                    placeholderText="Selecione ... (opcional)"
                    minDate={ subtrairDias(new Date(),365) }
                    maxDate={ somarDias(new Date(),365) }
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={ props.dataAcontecimento }
                    onChange={ date => props.setDataAcontecimento(date) }
                />
            </div>
            <div className="ml-3 mt-4">
                <div className="d-flex justify-content-between">
                    <button 
                        type="button" 
                        className="btn btn-outline-primary" 
                        onClick={ abreFormularioLocal }
                    >
                        Anterior
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-outline-primary " 
                        onClick={ abreFormularioEnvolvidos }
                    >
                        Próximo
                    </button>
                </div>
            </div>
        </fieldset>
    )
}